<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Opleidingen</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setStudy()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add Opleiding
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
import { API_ROOT } from "../../config";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "studys",
	data() {
		return {
			//user: localStorage.getItem("user"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Sector", value: "tbl_sys_sector.name" },
				{ text: "Niveau", value: "tbl_sys_level.name" },
				{ text: "Opleiding", value: "name" },
				{ text: "Estudio", value: "name_pap" },
				{ text: "Inschrijfgeld", value: "registration_cost" },
				{ text: "Schoolgeld", value: "study_cost" },
				{ text: "Materiaalkosten", value: "material_cost" },
				{ text: "Tonen inschrijving", value: "publish"},
				{ text: "Tonen event", value: "publish_event"},
				{ text: "Tonen cursus", value: "publish_course"},
				{ text: "Email Coordinator", value: "email_coordinator"},
				{ text: "Coordinator", value: "tbl_user.display_name"},
				// { text: "First Check", value: "firstcheckby"},
				// { text: "Second Check",	value: "secondcheckby"},
				// { text: "Active", value: "tbl_study.study_active" }

			],
			// semesters: [],
			// studies: [],
			// studys: [],
			// studytypes: [],
			// selected_study: null,
			// selected_kwalificatie: null,
			// selected_deelkwalificatie: null,
			// selected_semester: null,
			// schoolyear: [],
			// selected_schoolyear: null,
			data: [],
			// banktypes: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		// this.getBanktypes();
		this.getStudys();
	},
	watch: {
		// selected_kwalificatie: function(value) {
		// 	this.getStudyStudytype(value);
		// 	console.log(value);
		// }
	},
	computed: {
		// school() {
		// 	return this.$store.getters.getSchool;
		// }
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/study/update/" + id
			});
		},
		setStudy: function() {
			this.$router.push({
				path: "/schooladmin/study/new"
			});
		},
		getStudys: function() {
			var self = this;
			this.loading = true;
			ax.get("/study/all").then(function(response) {
					// console.log(response.data);
				self.data = response.data;
				console.log("Studys fetched...");
				console.log(response.data);
				self.loading = false;
			});
		},
		// getBanktypes: function() {
		// 	var self = this;
		// 	ax.get("/banktype/all").then(function(response) {
		// 		console.log(response.data);
		// 		self.banktypes = response.data;
		// 	});
		// }
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>